import service from '../allservices.jsx'

export function countryService(actionCallback) {
    fetch(service.country)
        .then(response => {
            if (response.status === 200) {
                return response.json()
            } else {
               
            }

        })
        .then(json => actionCallback(json))
}


// WEBPACK FOOTER //
// ./src/services/components/country_service.jsx